import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './AppIcon';
import Button from './ui/Button';

const AuthPromptModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-lg shadow-xl p-4 sm:p-6 max-w-xs sm:max-w-sm w-full text-center relative">
        {/* Close button - more visible */}
        <button
          onClick={onClose}
          className="absolute -top-2 -right-2 w-8 h-8 bg-primary hover:bg-primary/80 text-white rounded-full flex items-center justify-center transition-colors shadow-lg"
        >
          <Icon name="X" size={16} />
        </button>

        {/* Small prominent text */}
        <div className="text-2xl sm:text-3xl font-black text-primary mb-3 select-none">
          SIGN UP REQUIRED
        </div>

        {/* Main heading - much smaller */}
        <h2 className="text-lg sm:text-xl font-bold text-text-primary mb-2">
          Bulk Validation Needs Account! 🚀
        </h2>

        {/* Subtitle - smaller */}
        <p className="text-xs sm:text-sm text-text-secondary mb-4">
          Sign up to unlock bulk email validation • 100 FREE credits
        </p>

        {/* Benefits list - very compact */}
        <div className="space-y-1 mb-4">
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircle" size={12} className="text-success flex-shrink-0" />
            <span className="text-xs text-text-primary">AI-based validation accuracy</span>
          </div>
          
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircle" size={12} className="text-success flex-shrink-0" />
            <span className="text-xs text-text-primary">Free forever plan</span>
          </div>
          
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircle" size={12} className="text-success flex-shrink-0" />
            <span className="text-xs text-text-primary">API solutions & webhooks</span>
          </div>
          
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircle" size={12} className="text-success flex-shrink-0" />
            <span className="text-xs text-text-primary">Real-time validation results</span>
          </div>
          
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircle" size={12} className="text-success flex-shrink-0" />
            <span className="text-xs text-text-primary">Bulk processing & reports</span>
          </div>
          
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircle" size={12} className="text-success flex-shrink-0" />
            <span className="text-xs text-text-primary">Company domain intelligence</span>
          </div>
        </div>

        {/* Action buttons - smaller */}
        <div className="flex flex-col gap-2">
          <Link to="/auth/register" onClick={onClose} className="w-full">
            <Button
              variant="primary"
              size="sm"
              iconName="UserPlus"
              iconPosition="left"
              animation="bounce"
              className="w-full text-sm"
            >
              Sign Up Free
            </Button>
          </Link>
          <Link to="/auth/login" onClick={onClose} className="w-full">
            <Button
              variant="outline"
              size="sm"
              iconName="LogIn"
              iconPosition="left"
              animation="slide"
              className="w-full text-sm"
            >
              Sign In
            </Button>
          </Link>
        </div>

        {/* Footer text - very small */}
        <div className="mt-3 text-xs text-text-secondary">
          <p>
            By signing up, you agree to our{' '}
            <Link to="/terms" className="text-primary hover:text-primary/80 underline">
              Terms
            </Link>{' '}
            &{' '}
            <Link to="/privacy" className="text-primary hover:text-primary/80 underline">
              Privacy Policy
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthPromptModal; 